var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSignup)?_c('SignupCard',{attrs:{"redirect":_vm.redirect,"clickLoginEvent":true},on:{"click-login":_vm.toggleCard}}):_c('LoginCard',{attrs:{"redirect":_vm.redirect,"clickSignupEvent":true},on:{"click-signup":_vm.toggleCard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }